<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Heartful Business</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-authors">About the Authors</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a></li>
<li id="toc-li-6"><a href="#/text/ch006#part-1-the-five-underpinning-principles">Part 1 – The Five
          Underpinning Principles</a>
<ol>
<li id="toc-li-7"><a href="#/text/ch007#chapter-1-greater-good-its-about-more-than-you">Chapter 1: Greater
              Good – It’s About More Than You</a>
<ol class="toc">
<li id="toc-li-8"><a href="#/text/ch007#seeing-through-the-lens-of-a-consumer">Seeing through the lens
                  of
                  a consumer</a></li>
</ol>
</li>
<li id="toc-li-9"><a href="#/text/ch008#chapter-2-interdependence-we-are-all-one">Chapter 2:
              Interdependence –
              We Are All One</a>
<ol class="toc">
<li id="toc-li-10"><a href="#/text/ch008#interdependence-in-organisations">Interdependence in
                  organisations</a></li>
<li id="toc-li-11"><a href="#/text/ch008#cause-and-effect">Cause and effect</a></li>
<li id="toc-li-12"><a href="#/text/ch008#emergence-and-interdependence">Emergence and
                  interdependence</a>
</li>
<li id="toc-li-13"><a href="#/text/ch008#b-corp-declaration-of-interdependence">B Corp Declaration of
                  Interdependence</a></li>
</ol>
</li>
<li id="toc-li-14"><span href="#/text/ch009#chapter-3-economy-its-way-more-than-money" title="Link target outside of Sample">Chapter 3: Economy –
              It’s
              Way More Than Money</span>
<ol class="toc">
<li id="toc-li-15"><span href="#/text/ch009#shareholdersinvestors" title="Link target outside of Sample">Shareholders/investors</span></li>
<li id="toc-li-16"><span href="#/text/ch009#new-economic-models-sharing-circular-doughnut" title="Link target outside of Sample">New economic
                  models (sharing, circular, doughnut)</span></li>
<li id="toc-li-17"><span href="#/text/ch009#expanded-definition-of-economy" title="Link target outside of Sample">Expanded definition of
                  economy</span></li>
</ol>
</li>
<li id="toc-li-18"><span href="#/text/ch010#chapter-4-consciousness-you-do-have-a-soul" title="Link target outside of Sample">Chapter 4:
              Consciousness
              – You Do Have A Soul</span></li>
<li id="toc-li-19"><span href="#/text/ch011#chapter-5-ethics-and-morality-old-fashioned-concepts-that-are-more-important-than-ever" title="Link target outside of Sample">Chapter
              5: Ethics and Morality – Old Fashioned Concepts That Are More Important Than Ever</span></li>
</ol>
</li>
<li id="toc-li-20"><span href="#/text/ch012#part-2-the-five-qualities-of-conscious-leadership" title="Link target outside of Sample">Part 2 – The Five
          Qualities of Conscious Leadership</span>
<ol>
<li id="toc-li-21"><span href="#/text/ch013#chapter-6-purpose-is-your-north-star-shining" title="Link target outside of Sample">Chapter 6: Purpose
              – Is
              Your North Star Shining?</span></li>
<li id="toc-li-22"><span href="#/text/ch014#chapter-7-heartful-leadership-whats-love-got-to-do-with-it" title="Link target outside of Sample">Chapter
              7: Heartful Leadership – What’s Love Got to Do with It</span></li>
<li id="toc-li-23"><span href="#/text/ch015#chapter-8-presence-i-am-fully-here-right-now" title="Link target outside of Sample">Chapter 8: Presence
              – I
              Am Fully Here, Right Now</span></li>
<li id="toc-li-24"><span href="#/text/ch016#chapter-9-knowing-theres-more-to-life-than-facts" title="Link target outside of Sample">Chapter 9:
              Knowing
              – There’s More to Life Than Facts</span></li>
<li id="toc-li-25"><span href="#/text/ch017#chapter-10-intention-turbo-charging-our-will-to-good" title="Link target outside of Sample">Chapter 10:
              Intention – Turbo-Charging Our Will to Good</span></li>
</ol>
</li>
<li id="toc-li-26"><span href="#/text/ch018#part-3-the-five-practices" title="Link target outside of Sample">Part 3 – The Five Practices</span>
<ol>
<li id="toc-li-27"><span href="#/text/ch019#chapter-11-reflective-practice" title="Link target outside of Sample">Chapter 11: Reflective
              Practice</span>
</li>
<li id="toc-li-28"><span href="#/text/ch020#chapter-12-self-awareness" title="Link target outside of Sample">Chapter 12: Self-Awareness</span></li>
<li id="toc-li-29"><span href="#/text/ch021#chapter-13-embracing-systems" title="Link target outside of Sample">Chapter 13: Embracing ‘Systems’</span>
<ol class="toc">
<li id="toc-li-30"><span href="#/text/ch021#resilience-in-uncertainty" title="Link target outside of Sample">Resilience in uncertainty</span></li>
<li id="toc-li-31"><span href="#/text/ch021#building-dialogue" title="Link target outside of Sample">Building dialogue</span></li>
<li id="toc-li-32"><span href="#/text/ch021#balancing-polarities" title="Link target outside of Sample">Balancing polarities</span></li>
</ol>
</li>
<li id="toc-li-33"><span href="#/text/ch022#chapter-14-transformational-team-working-becoming-group-conscious" title="Link target outside of Sample">Chapter
              14:
              Transformational Team Working – Becoming Group Conscious</span></li>
<li id="toc-li-34"><span href="#/text/ch023#chapter-15-activism-the-call-to-act" title="Link target outside of Sample">Chapter 15: Activism – The
              Call
              to Act</span></li>
</ol>
</li>
<li id="toc-li-35"><span href="#/text/ch024#the-story-of-the-book" title="Link target outside of Sample">The Story of the Book</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?0c60fec8